import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


interface Props {
    tabs: {
        displayName: string;
        typeName: string;
        hasDisputedAnswers: boolean;
    }[];
    activeTab?: string; // active tab is a TypeName NOT a DisplayName
    onClick: (typeName: string) => void;
}


const AcxScrollingTabs = (props: Props) => {
    const [value, setValue] = React.useState(0);

    useEffect(() => {
        if (props.activeTab) {
            setValue(
                props.tabs.findIndex((tab) => tab.typeName === props.activeTab),
            );
        }
    }, [props.activeTab, props.tabs]);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Tabs
            sx={{
                justifyContent: "center",
                "& .MuiTabs-scroller": { flexGrow: 0 },
            }}
            value={value}
            onChange={handleChange}
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
                style: {
                    display: "none",
                },
            }}
        >
            {props.tabs.map((tab, index) => (
                <Tab
                    key={`${tab.displayName}_${index}`}
                    id={`${tab.displayName}_${index}`}
                    wrapped
                    label={tab.displayName}
                    onClick={(event) => props.onClick(tab.typeName)}
                    sx={{
                        minWidth: "min-content",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        paddingRight: "20px",
                        color: tab.hasDisputedAnswers ? "red" : "",
                        "&::after": {
                            content: '"•"',
                            display: props.tabs[index + 1] ? "block" : "none",
                            position: "absolute",
                            right: "0",
                            color: "gray",
                        },
                    }}
                />
            ))}
        </Tabs>
    );
};

export default AcxScrollingTabs;
